import { Injectable } from '@angular/core';
import { Apollo } from "apollo-angular";
import FundType from "../../interfaces/fund-type";
import { BehaviorSubject, Subscription } from "rxjs";
import { CREATE_FUND, CreateFundInput, GET_FUND_INFO } from "./graphql/add-fund";
import { DefaultSnackBarService } from "../../services/default-snack-bar.service";
import {nav_search_funds} from "../../side-nav/cw-search/graphql/navSearchFunds";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AddFundService {

  private _fundTypes: FundType[] = [];
  private fundTypes = new BehaviorSubject(this._fundTypes);
  public fundTypes$ = this.fundTypes.asObservable();
  constructor(public apollo: Apollo, private _snackBar: DefaultSnackBarService) { }

  private _setFundTypes(fundTypes: FundType[]) {
    this._fundTypes = fundTypes;
    this.fundTypes.next(this._fundTypes);
  }

  public getFundInfo(){
    let sub:Subscription;
    sub = this.apollo.query({query:GET_FUND_INFO}).subscribe(({data})=>{
      if(data?.fundTypes){
        this._setFundTypes(data.fundTypes);
      }
      sub?.unsubscribe();
    });
  }

  public fundNameCheck(value:string){
    return this.apollo.query({
      query: nav_search_funds,
      variables: {
        searchLike: '%' + value.trim() + '%',
        search: value.trim(),
        limit: 10,
        page: 1,
      }
    }).pipe(
      map(
        (data:any) => {
          let result = data.data.search_funds.data
          return result.filter((rs:any) => rs.name == value.trim()).length > 0
        }
      )
    )
  }

  public createFund(input: CreateFundInput){
    return this.apollo.mutate({mutation:CREATE_FUND, variables:{input}});
  }

}
